var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.primary)?_c('section',{class:_vm.$style.container,attrs:{"data-luko-tracking":"Disclaimer"}},[_c('Wrapper',{class:_vm.$style.inner},[_c('RichText',{class:_vm.$style.text,attrs:{"text-params":_vm.primary.text}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }